import http from './http'

export default {
  getList: params => http.get('/v2/committees', { params }),
  remove: id => http.post('/admin/committee-delete', { id }, { silent: true, localSuccess: true }),
  getSecretaries: () => http.get('/v2/committees/secretaries'),
  getSwitchable: params => http.get('/v2/committees/switchable', { params }),
  drafts: params => http.get('/v2/committees/drafts', { params }),
  getBulkMailingOptions: () => http.get('/v2/committees/bulk-mailing/options'),
  getBulkMailingSearch: params => http.get('/v2/committees/bulk-mailing/search', { params }),
  sendBulkMailing: data => http.post('/v2/committees/bulk-mailing', data, { silent: true }),
  getUserNominations: (draftId, userId) => http.get(`/v2/committees/${draftId}/users/${userId}/nominations`),
  updateNominationList: data => http.patch('/v2/committees/nominations/lists', data, { silent: true, localSuccess: true })
}



// WEBPACK FOOTER //
// ./src/services/api/committees.js